import { render, staticRenderFns } from "./InterazioneFarmaciModal.vue?vue&type=template&id=2fa3aebe&scoped=true"
import script from "./InterazioneFarmaciModal.vue?vue&type=script&lang=js"
export * from "./InterazioneFarmaciModal.vue?vue&type=script&lang=js"
import style0 from "./InterazioneFarmaciModal.vue?vue&type=style&index=0&id=2fa3aebe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fa3aebe",
  null
  
)

export default component.exports